/**
 * @file コンポーネント：フル動画ページタイムライン機器 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル設定読み込み
import {
    StyledList,
    StyledListItem,
    StyledListItemIcon,
    StyledListItemText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledList>
            {props.listDevice.map((device, index) => (
                <StyledListItem key={"device-" + index}>
                    <StyledListItemIcon>
                        <i className="fas fa-briefcase-medical"></i>
                    </StyledListItemIcon>
                    <StyledListItemText>{device.deviceName}</StyledListItemText>
                </StyledListItem>
            ))}
        </StyledList>
    );
};
